import { Box, useTheme, Typography,  } from '@mui/material';
import Header from '../../components/Header';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { tokens } from '../../theme';

const FAQ = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Box m='20px' >
            <Header title='FAQ' subtitle='Frequently Askes Questions Page'
            />

            <Accordion defaultExpanded >
                <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                    <Typography color={colors.greenAccent[500]} variant='h5' >
                        An Important question
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                    Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut illum incidunt ipsam recusandae ullam vero quam earum doloribus id in repudiandae nemo, dolorem eaque itaque unde? Dicta vero eaque ratione.
                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Accordion defaultExpanded >
                <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                    <Typography color={colors.greenAccent[500]} variant='h5' >
                        Another Important question
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                    Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut illum incidunt ipsam recusandae ullam vero quam earum doloribus id in repudiandae nemo, dolorem eaque itaque unde? Dicta vero eaque ratione.
                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Accordion defaultExpanded >
                <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                    <Typography color={colors.greenAccent[500]} variant='h5' >
                        Your favorite Question
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                    Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut illum incidunt ipsam recusandae ullam vero quam earum doloribus id in repudiandae nemo, dolorem eaque itaque unde? Dicta vero eaque ratione.
                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Accordion defaultExpanded >
                <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                    <Typography color={colors.greenAccent[500]} variant='h5' >
                        Some Random Question
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                    Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut illum incidunt ipsam recusandae ullam vero quam earum doloribus id in repudiandae nemo, dolorem eaque itaque unde? Dicta vero eaque ratione.
                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Accordion defaultExpanded >
                <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                    <Typography color={colors.greenAccent[500]} variant='h5' >
                        The Final Question
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                    Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut illum incidunt ipsam recusandae ullam vero quam earum doloribus id in repudiandae nemo, dolorem eaque itaque unde? Dicta vero eaque ratione.
                    </Typography>
                </AccordionDetails>
            </Accordion>


        </Box>
    );
}

export default FAQ;